import React, { useEffect, useState } from "react";
import OfflineOrderListing from "./OfflineOrderListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setIsOpenEditDialog,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/OfflineOrderSlice";
import { useGetAllOfflineOrderDataQuery } from "src/services/OfflineOrderService";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import { Tooltip } from "@mui/material";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import CancelOrderFormWrapper from "../Cancel/CancelAdvancePaymentWrapper";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const OfflineOrderListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isOpenEditDialog,
    isTableLoading,
    dateFilter,
  } = useSelector((state: RootState) => state.offlineOrder);
  const [selectedOrderId, setSelectedOrderId] =
    useState<string>();
  const { data, isLoading, isFetching } = useGetAllOfflineOrderDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name", "email", "mobile", "orderId"],
    page: page,
    filterBy: [],
    dateFilter: dateFilter,
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);
const moduleName = "ORDER";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");
  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date - Time",

      extraClasses: "min-w-[150px] py-1 min-w-[150px]",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium text-[14px]">
            {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
          </div>
          <div className="text-[12px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row.createdAt, "hh:mm A")}
          </div>
        </div>
      ),
    },

    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.name}>
          <div className="capitalize text-[13px]"> {row?.name} </div>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.email}>
          <div className="capitalize text-[13px]"> {row?.email} </div>
        </Tooltip>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <div className="capitalize text-[13px]"> {row?.mobile} </div>
      ),
    },
    {
      field: "orderTotal",
      headerName: "Order Total",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.orderTotal}</div>,
    },
    {
      field: "receivedAmt",
      headerName: "Recived Amount",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.receivedAmt}</div>,
    },
    {
      field: "dueAmt",
      headerName: "Due Amount",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.dueAmt}</div>,
    },
   {
  field: "action",
  headerName: "Actions",
  flex: "flex-[1_1_0%]",
  extraClasses: "",
  renderCell: (row: any) => {
    const options = [];

    if (canEdit) {
      options.push({
        label: "Cancel",
        onClick: () => {
          dispatch(setIsOpenEditDialog(true));
          setSelectedOrderId(row?._id);
        },
      });
    }

    return <ATMMenu options={options} />;
  },
}
  ];

  return (
    <div>
      <OfflineOrderListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenEditDialog ? (
        <CancelOrderFormWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedOrderId={selectedOrderId || ""}
        />
      ) : null}
    </div>
  );
};

export default OfflineOrderListingWrapper;
